import { List } from 'immutable';
import isEqual from 'hs-lodash/isEqual';
import * as AuditEventTypes from 'automation-ui-management/records/AuditHistory/AuditEventTypes';
import * as AuditEventSubTypes from 'automation-ui-management/records/AuditHistory/AuditEventSubTypes';
export function didEnableWorkflow(revision, nextRevision) {
  const isEnabled = revision.flow.isEnabled;
  const nextIsEnabled = nextRevision.flow.isEnabled;
  return !isEnabled && nextIsEnabled;
}
export function didDisableWorkflow(revision, nextRevision) {
  const isEnabled = revision.flow.isEnabled;
  const nextIsEnabled = nextRevision.flow.isEnabled;
  return isEnabled && !nextIsEnabled;
}
export function didModifyEnrollment(revision, nextRevision) {
  const isClassicWorkflow = revision.flow.isClassicWorkflow;
  if (isClassicWorkflow) {
    const classicEnrollmentSettings = revision.flow.classicEnrollmentSettings;
    const nextClassicEnrollmentSettings = nextRevision.flow.classicEnrollmentSettings;
    if (classicEnrollmentSettings && nextClassicEnrollmentSettings) {
      return !isEqual(classicEnrollmentSettings.segmentCriteria, nextClassicEnrollmentSettings.segmentCriteria);
    }
  }
  const maybeEnrollmentList = revision.flow.associatedLists.find(list => list.listTypes.includes('ENROLLMENT_LIST'));
  const maybeNextEnrollmentList = nextRevision.flow.associatedLists.find(list => list.listTypes.includes('ENROLLMENT_LIST'));
  return !isEqual(maybeEnrollmentList && maybeEnrollmentList.filterBranch, maybeNextEnrollmentList && maybeNextEnrollmentList.filterBranch);
}
export function didModifyUnenrollment(revision, nextRevision) {
  const isClassicWorkflow = revision.flow.isClassicWorkflow;
  if (isClassicWorkflow) {
    const classicEnrollmentSettings = revision.flow.classicEnrollmentSettings;
    const nextClassicEnrollmentSettings = nextRevision.flow.classicEnrollmentSettings;
    if (classicEnrollmentSettings && nextClassicEnrollmentSettings) {
      return !isEqual(classicEnrollmentSettings.unenrollmentSetting, nextClassicEnrollmentSettings.unenrollmentSetting) || classicEnrollmentSettings.listening !== nextClassicEnrollmentSettings.listening;
    }
  }
  const maybeSuppressiontList = revision.flow.associatedLists.find(list => list.listTypes.includes('SUPPRESSION_LIST'));
  const maybeNextSuppressionList = nextRevision.flow.associatedLists.find(list => list.listTypes.includes('SUPPRESSION_LIST'));
  return !isEqual(maybeSuppressiontList && maybeSuppressiontList.filterBranch, maybeNextSuppressionList && maybeNextSuppressionList.filterBranch);
}
export function didModifyReenrollment(revision, nextRevision) {
  function compareReEnrollmentTriggerSets(a, b) {
    var _ref, _a$, _b$0$id$toString, _b$, _a$2, _b$1$id$toString, _b$2;
    if (a.length !== b.length) {
      return a.length - b.length;
    }

    // First compare the ids of the first element in the tuple, then the second element in the tuple, if they exist.
    // If they're both the same (which shouldn't be possilbe), return 0.
    return (_ref = ((_a$ = a[0]) === null || _a$ === void 0 || (_a$ = _a$.id) === null || _a$ === void 0 ? void 0 : _a$.toString().localeCompare((_b$0$id$toString = (_b$ = b[0]) === null || _b$ === void 0 || (_b$ = _b$.id) === null || _b$ === void 0 ? void 0 : _b$.toString()) !== null && _b$0$id$toString !== void 0 ? _b$0$id$toString : '')) || ((_a$2 = a[1]) === null || _a$2 === void 0 || (_a$2 = _a$2.id) === null || _a$2 === void 0 ? void 0 : _a$2.toString().localeCompare((_b$1$id$toString = (_b$2 = b[1]) === null || _b$2 === void 0 || (_b$2 = _b$2.id) === null || _b$2 === void 0 ? void 0 : _b$2.toString()) !== null && _b$1$id$toString !== void 0 ? _b$1$id$toString : ''))) !== null && _ref !== void 0 ? _ref : 0;
  }
  const isClassicWorkflow = revision.flow.isClassicWorkflow;
  if (isClassicWorkflow) {
    const classicEnrollmentSettings = revision.flow.classicEnrollmentSettings;
    const nextClassicEnrollmentSettings = nextRevision.flow.classicEnrollmentSettings;
    if (classicEnrollmentSettings && nextClassicEnrollmentSettings) {
      var _classicEnrollmentSet, _nextClassicEnrollmen;
      return !isEqual([...((_classicEnrollmentSet = classicEnrollmentSettings.reEnrollmentTriggerSets) !== null && _classicEnrollmentSet !== void 0 ? _classicEnrollmentSet : [])].sort(compareReEnrollmentTriggerSets), [...((_nextClassicEnrollmen = nextClassicEnrollmentSettings.reEnrollmentTriggerSets) !== null && _nextClassicEnrollmen !== void 0 ? _nextClassicEnrollmen : [])].sort(compareReEnrollmentTriggerSets));
    }
  }
  const maybeReEnrollmentList = revision.flow.associatedLists.find(list => list.listTypes.some(listType => ['RE_ENROLLMENT_LIST', 'PERSISTED_RE_ENROLLMENT_LIST'].includes(listType)));
  const maybeNextReEnrollmentList = nextRevision.flow.associatedLists.find(list => list.listTypes.some(listType => ['RE_ENROLLMENT_LIST', 'PERSISTED_RE_ENROLLMENT_LIST'].includes(listType)));
  return !isEqual(maybeReEnrollmentList && maybeReEnrollmentList.filterBranch, maybeNextReEnrollmentList && maybeNextReEnrollmentList.filterBranch);
}
export function didEnableReenrollment(revision, nextRevision) {
  const shouldReenroll = revision.flow.shouldReenroll;
  const nextShouldReenroll = nextRevision.flow.shouldReenroll;
  return !shouldReenroll && nextShouldReenroll;
}
export function didDisableReenrollment(revision, nextRevision) {
  const shouldReenroll = revision.flow.shouldReenroll;
  const nextShouldReenroll = nextRevision.flow.shouldReenroll;
  return shouldReenroll && !nextShouldReenroll;
}
export function didModifyGoals(revision, nextRevision) {
  const isClassicWorkflow = revision.flow.isClassicWorkflow;
  if (isClassicWorkflow) {
    const goalCriteria = revision.flow.classicEnrollmentSettings.goalCriteria;
    const nextGoalCriteria = nextRevision.flow.classicEnrollmentSettings.goalCriteria;
    return !isEqual(goalCriteria, nextGoalCriteria);
  }
  return false;
}
export function didModifyName(revision, nextRevision) {
  const name = revision.flow.name;
  const nextName = nextRevision.flow.name;
  return name !== nextName;
}
export function didAddAction(revision, nextRevision) {
  const actions = revision.flow.actions;
  const nextActions = nextRevision.flow.actions;
  return Object.keys(nextActions).length > Object.keys(actions).length;
}
export function didEditAction(revision, nextRevision) {
  const actions = revision.flow.actions;
  const nextActions = nextRevision.flow.actions;
  if (Object.keys(nextActions).length === Object.keys(actions).length) {
    for (const key of Object.keys(actions)) {
      if (!nextActions[key] || !isEqual(actions[key], nextActions[key])) {
        return true;
      }
    }
  }
  return false;
}
export function didDeleteAction(revision, nextRevision) {
  const actions = revision.flow.actions;
  const nextActions = nextRevision.flow.actions;
  return Object.keys(nextActions).length < Object.keys(actions).length;
}
export function didModifyTimeWindow(revision, nextRevision) {
  const timeWindow = revision.flow.timeWindow;
  const nextTimeWindow = nextRevision.flow.timeWindow;
  return !isEqual(timeWindow, nextTimeWindow);
}
export function didModifyMergeSetting(revision, nextRevision) {
  const isClassicWorkflow = revision.flow.isClassicWorkflow;
  if (isClassicWorkflow) {
    const classicEnrollmentSettings = revision.flow.classicEnrollmentSettings;
    const nextClassicEnrollmentSettings = nextRevision.flow.classicEnrollmentSettings;
    if (classicEnrollmentSettings && nextClassicEnrollmentSettings) {
      return classicEnrollmentSettings.allowEnrollmentFromMerge !== nextClassicEnrollmentSettings.allowEnrollmentFromMerge;
    }
  }
  return false;
}
export function didModifySuppressionList(revision, nextRevision) {
  const isClassicWorkflow = revision.flow.isClassicWorkflow;
  if (isClassicWorkflow) {
    const classicEnrollmentSettings = revision.flow.classicEnrollmentSettings;
    const nextClassicEnrollmentSettings = nextRevision.flow.classicEnrollmentSettings;
    if (classicEnrollmentSettings && nextClassicEnrollmentSettings) {
      return !isEqual(classicEnrollmentSettings.suppressionListIds, nextClassicEnrollmentSettings.suppressionListIds);
    }
  }
  return false;
}
const AuditEventTypeToComparison = {
  [AuditEventTypes.ENABLED_TOGGLED]: didEnableWorkflow,
  [AuditEventTypes.DISABLED_TOGGLED]: didDisableWorkflow,
  [AuditEventTypes.ENROLLMENT_MODIFIED]: didModifyEnrollment,
  [AuditEventTypes.ENABLED_REENROLLMENT]: didEnableReenrollment,
  [AuditEventTypes.DISABLED_REENROLLMENT]: didDisableReenrollment,
  [AuditEventTypes.REENROLLMENT_MODIFIED]: didModifyReenrollment,
  [AuditEventTypes.UNENROLLMENT_MODIFIED]: didModifyUnenrollment,
  [AuditEventTypes.GOALS_MODIFIED]: didModifyGoals,
  [AuditEventTypes.EDITED_NAME]: didModifyName,
  [AuditEventSubTypes.ADDED_ACTION]: didAddAction,
  [AuditEventSubTypes.EDITED_ACTION]: didEditAction,
  [AuditEventSubTypes.DELETED_ACTION]: didDeleteAction,
  [AuditEventTypes.TIME_WINDOW_MODIFIED]: didModifyTimeWindow,
  [AuditEventTypes.MERGE_SETTING_MODIFIED]: didModifyMergeSetting,
  [AuditEventTypes.SUPPRESSION_LIST_MODIFIED]: didModifySuppressionList
};
export function getDeletedActionCount(revision, nextRevision) {
  const actions = revision.flow.actions;
  const nextActions = nextRevision.flow.actions;
  return Object.keys(actions).length - Object.keys(nextActions).length;
}
export function getAuditEventTypes(revision, nextRevision) {
  const auditEventTypes = [];
  Object.keys(AuditEventTypeToComparison).forEach(auditEventType => {
    const comparisonFunc = AuditEventTypeToComparison[auditEventType];
    if (comparisonFunc(revision, nextRevision)) {
      auditEventTypes.push(auditEventType);
    }
  });
  if (auditEventTypes.length === 0) {
    auditEventTypes.push(AuditEventTypes.UNKNOWN_AUDIT_EVENT_TYPE);
  }
  return List(auditEventTypes);
}